<template>
  <v-card>
    <v-card-title>
      Transakce
    </v-card-title>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1">
      <template #item.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.amount="{ item }">
        {{ formatAmount(item) }}
      </template>
      <template #item.originalAmount="{ item }">
        {{ formatOriginalAmount(item) }}
      </template>
      <template #item.fee="{ item }">
        {{ formatFee(item) }}
      </template>
      <template #item.action="{ item }">
        <v-btn v-if="item.cleaningService" outlined small color="primary" exact :to="'/app/cleaning-services/' + item.cleaningService">
          Úklidová služba
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {formatDatetime} from '@/helper/date-helper'
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'

export default {
  name: "UserTransactionsTable",
  props: {
    userId: {},
  },
  data() {
    return {
      headers: [
        {text: 'ID', value: 'id'},
        {text: 'Typ', value: 'type'},
        {text: 'Původná částka', value: 'originalAmount'},
        {text: 'Částka', value: 'amount'},
        {text: 'Poplatek', value: 'fee'},
        {text: 'Popis', value: 'description'},
        {text: 'Uklízecí služba', value: 'cleaningServiceName', sortable: false},
        {text: 'Adresa uklizecí služby', value: 'cleaningServiceAddress', sortable: false},
        {text: 'Zákazník', value: 'cleaningServiceCustomerEmail', sortable: false},
        {text: 'Vytvořeno', value: 'createdAt'},
        {text: 'Akce', value: 'action', sortable: false}
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      search: null
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.totalElements
    },
    items() {
      if (!this.data) return []
      return this.data.content
    }
  },
  methods: {
    getData() {
      const params = generateRequestParams(
          this.options.page,
          this.options.itemsPerPage,
          this.search,
          this.options.sortBy,
          this.options.sortDesc
      )
      params.append('user', this.userId)
      // this.axios.get('/api/admin/transaction', {
      //   params: params
      // })
      //     .then(({data}) => {
      //       this.data = data
      //     })
    },
    formatCreatedAt({createdAt}) {
      return formatDatetime(createdAt)
    },
    formatOriginalAmount({originalAmount}) {
      return originalAmount + " Kč"
    },
    formatAmount({amount}) {
      return amount + " Kč"
    },
    formatFee({fee}) {
      return fee + " %"
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'user-transactions')
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>